module.exports = __webpack_public_path__ + "static/img/tabela.67c5277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/refricola/tabela.png
// module id = w6KM
// module chunks = 0